<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  methods:{
    getUrl(url){
      if(/new/i.test(url)){
        localStorage.setItem('loginState',1)
      }else if(/old/i.test(url)){
        localStorage.setItem('loginState',0)
      }
    }
  },
  created() {
    const url = location.href;
    console.log(url)
    this.getUrl(url)
  }
};
</script>

<style>
#app,body,html {
  width: 100%;
  background: #F5F6F8 !important;
}
[v-cloak] {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue